
import XHeader from 'vux/src/components/x-header/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getBackendHost} from './libs/misc'

export default {
  directives: {
    TransferDom
  },
  components: {
    XHeader,
    Confirm
  },

  data () {
    return {
      show: true
    }
  },

  computed: {
  },

  methods: {
    onConfirm () {
      this.$vux.loading.show({
        transition: '',
        text: '跳转中...'
      })
      window.location = getBackendHost(window.location) + '/m/auth/register'
    }
  },

  async mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/Error.vue